import { html, rune, View } from 'rune-ts';
import { makeEmptyScreenNavigate } from '../../../../shared/app/navigate';
import { dataStr } from '../../../../shared/util/dataStr';
import klass from './PopupStoreItemCard.module.scss';
import { staticTypoPcMo, typo, typoPcMo } from '../../../../shared/typography/typo';
import { PopupStoreVisualCardProps } from './PopupStoreVisualCard';
import { UtilImageS } from '../../../../../../modules/Util/Image/S/Function/module/UtilImageS';
import { format, isBefore } from 'date-fns';
import { htmlIf } from '../../../../shared/util';

export type PopupStoreItemCardProps = Omit<PopupStoreVisualCardProps, 'list'> & {
  use_in?: 'popup_store' | 'search';
};

export class PopupStoreItemCard extends View<PopupStoreItemCardProps> {
  getStatusText() {
    const { start_at, end_at } = this.data.item;
    const today = format(new Date(), 'yyyy-MM-dd HH:mm');

    if (start_at <= today && today <= end_at) return 'Now';
    else if (today > end_at) return ET('mps2::popup_store::status::closed');
    else return 'Upcoming';
  }

  calcRate() {
    const { goal_type, goal_value, sold_count, sold_price } = this.data.item;
    return Math.round(((goal_type === 'count' ? sold_count : sold_price) / goal_value) * 100);
  }

  protected override template() {
    const { item, use_in } = this.data;
    const is_mobile = rune.getSharedData(this)?.is_mobile;
    const title_class = use_in === 'search' ? '20_bold' : '24_bold';
    const is_upcoming = isBefore(new Date(), new Date(item.start_at));

    return html`
      <div class="${klass.popup_store_item_card}">
        <div class="${klass.image} ${use_in === 'search' && is_upcoming ? klass.dimmed : ''}">
          ${is_upcoming
            ? html`
                <div>
                  <img
                    src="${UtilImageS.getResizedUrl({
                      url: item.list_thumbnail,
                      width: 1920 * 2,
                      format: 'jpeg',
                      quality: 85,
                    })}"
                  />
                </div>
              `
            : html`
                <a
                  href="${`/${ET.lang}/@/popup-store/${item.id}`}"
                  data-post-message="${dataStr(
                    makeEmptyScreenNavigate(`/${ET.lang}/@/popup-store/${item.id}`),
                  )}"
                >
                  <img
                    src="${UtilImageS.getResizedUrl({
                      url: item.list_thumbnail,
                      width: 1920 * 2,
                      format: 'jpeg',
                      quality: 85,
                    })}"
                  />
                </a>
              `}

          <div
            class="${klass.badges} ${staticTypoPcMo({
              is_mobile,
              pc: 'unica_14_regular',
              mo: 'unica_12_regular',
            })}"
          >
            <p class="${klass.badge}">Pop-up Store #${item.numbering}</p>
            <p class="${klass.badge}">${this.getStatusText()}</p>
          </div>
        </div>

        <div class="${klass.meta}">
          <h3 class="${klass.title} ${typo(is_mobile ? '16_bold' : title_class)}">
            ${is_upcoming
              ? html`<span>${html.preventEscape(item.title)}</span>`
              : html` <a
                  href="${`/${ET.lang}/@/popup-store/${item.id}`}"
                  data-post-message="${dataStr(
                    makeEmptyScreenNavigate(`/${ET.lang}/@/popup-store/${item.id}`),
                  )}"
                  >${html.preventEscape(item.title)}</a
                >`}
          </h3>
          ${htmlIf(
            html`<div class="${klass.score} ${typoPcMo({ is_mobile, pc: '16_medium', mo: '14_medium' })}">
              ${html.preventEscape(item.soldout_label || '')}
            </div>`,
            item.is_soldout,
          )}
          ${item.creator_shop_url
            ? html`
                <a
                  href="${item.creator_shop_url}"
                  class="${klass.store} ${typoPcMo({ is_mobile, pc: '16_bold', mo: '14_bold' })}"
                >
                  ${html.preventEscape(item.creator_name)}
                </a>
              `
            : html`
                <span class="${klass.store} ${typoPcMo({ is_mobile, pc: '16_bold', mo: '14_bold' })}">
                  ${html.preventEscape(item.creator_name)}
                </span>
              `}

          <div
            class="${klass.date} ${staticTypoPcMo({
              is_mobile,
              pc: 'unica_16_medium',
              mo: 'unica_14_medium',
            })}"
          >
            ${format(new Date(item.start_at), 'yyyy-MM-dd')} ~ ${format(new Date(item.end_at), 'yyyy-MM-dd')}
          </div>
        </div>
      </div>
    `;
  }
}
